module.exports = __webpack_public_path__ + "img/rebranding-ar.bb2d8236.png";